module.exports = __webpack_public_path__ + "static/media/sc.ab2cdd43.svg";